export function isNonNull<T>(value: T): value is NonNullable<T> {
  return value != null;
}

export function isNonUndefined<T>(value: T): value is NonNullable<T> {
  return value != undefined;
}

